import Vue from "vue";
import RoFolderView from "./RoFolderView";

Vue.component("ro-folder-view", RoFolderView);
export default RoFolderView;



// WEBPACK FOOTER //
// ./scripts/ro-folder-view/index.js